/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

export default function TokenStorageBridge() {
  const {
    isAuthenticated,
    signinRedirect,
    signinSilent,
    signoutRedirect,
    user,
  } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      const accessToken = user?.access_token;
      const idToken = user?.id_token;
      const refreshToken = (user as any)?.refresh_token;

      if (accessToken) sessionStorage.setItem('TOKEN', accessToken);
      if (idToken) sessionStorage.setItem('ID_TOKEN', idToken);
      if (refreshToken) sessionStorage.setItem('REFRESH_TOKEN', refreshToken);
    } else {
      sessionStorage.removeItem('TOKEN');
      sessionStorage.removeItem('ID_TOKEN');
      sessionStorage.removeItem('REFRESH_TOKEN');
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    (window as any).oidcRenew = async () => {
      try {
        const user = await signinSilent();
        if (user?.access_token)
          sessionStorage.setItem('TOKEN', user.access_token);
        if ((user as any)?.refresh_token)
          sessionStorage.setItem('REFRESH_TOKEN', (user as any).refresh_token);
        if (user?.id_token) sessionStorage.setItem('ID_TOKEN', user.id_token);
        return true;
      } catch {
        return false;
      }
    };
    (window as any).oidcLogout = async () => {
      sessionStorage.removeItem('TOKEN');
      sessionStorage.removeItem('ID_TOKEN');
      sessionStorage.removeItem('REFRESH_TOKEN');
      try {
        await signoutRedirect();
      } catch {
        await signinRedirect();
      }
    };
  }, [signoutRedirect, signinRedirect, signinSilent]);

  return null;
}
